import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-popup-message',
    templateUrl: './popup-message.component.html',
    styleUrls: ['./popup-message.component.css'],
    standalone: false
})
export class PopupMessageComponent implements OnInit {
  @Input() icon_class: string;
  @Input() icon: string;
  @Input() message: string;

  constructor() {
  }

  ngOnInit() {
  }
}
